import { useEffect } from "react";

const PersonalCare = () => {
  useEffect(() => {
    document.title = "Personal Care - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/personal_care.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Personal Care</h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">
              {/* <h2>Personal Care</h2> */}

              <h2>Nature's Essence in Every Drop</h2>
              <h3>
                The Power of Natural Oils, Extracts, and Butters in Personal
                Care
              </h3>

              <p>
                At Deww Botanicals, we believe that truly effective personal
                care begins with clean, plant-based ingredients. That’s why we
                formulate our products with the purest essential oils, carrier
                oils, liquid herbal extracts, and plant butters—each selected
                for their time-tested benefits, therapeutic properties, and
                compatibility with skin and hair. These botanical treasures form
                the foundation of our personal care products, providing
                nourishment, protection, and long-term wellness.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?natural-skincare,personal-care"
                alt="Natural personal care products"
              /> */}

              <h3>Carrier Oils: Natural Moisture and Skin Nutrition</h3>

              <p>
                Our cold-pressed carrier oils are rich in vitamins, essential
                fatty acids, and antioxidants. They serve as the base for many
                personal care formulations, including:
              </p>
              <ul>
                <li>
                  Facial serums and creams for deep hydration and nourishment
                </li>
                <li>Body oils and massage blends for skin repair and toning</li>
                <li>
                  Hair care products that restore scalp health and enhance shine
                </li>
              </ul>

              <p>
                Examples include jojoba, argan, almond, and coconut oil—all
                non-comedogenic and beneficial for the skin.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?jojoba-oil,carrier-oil"
                alt="Carrier oils for skin and hair"
              /> */}

              <h3>
                Essential Oils: Natural Actives with Aromatherapeutic Benefits
              </h3>

              <p>
                Essential oils not only provide natural fragrance but also offer
                targeted skincare and wellness benefits. They are commonly used
                in:
              </p>
              <ul>
                <li>Face cleansers (e.g., tea tree oil for acne)</li>
                <li>
                  Hair oils and scalp serums (e.g., rosemary for hair growth)
                </li>
                <li>
                  Body scrubs, lotions, and mists for soothing and energizing
                  effects
                </li>
                <li>
                  Bath oils and roll-ons for stress relief and mood enhancement
                </li>
              </ul>

              <p>
                We utilize pure, steam-distilled oils such as lavender,
                peppermint, eucalyptus, frankincense, and neroli.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?essential-oil,spa"
                alt="Essential oils for wellness"
              /> */}

              <h3>Liquid Herbal Extracts: Potent Plant-Based Actives</h3>

              <p>
                Our liquid extracts are high-performance actives derived from
                herbs used in Ayurveda and modern skincare science. They are
                ideal for:
              </p>
              <ul>
                <li>Face masks and toners (e.g., turmeric, neem, aloe vera)</li>
                <li>
                  Anti-aging and brightening serums (e.g., licorice, amla, green
                  tea)
                </li>
                <li>
                  Hair-strengthening formulas (e.g., bhringraj, hibiscus,
                  fenugreek)
                </li>
              </ul>

              <p>
                These extracts deliver fast, visible results while remaining
                gentle and non-toxic.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?herbal-extracts,skincare"
                alt="Herbal extracts like turmeric and amla"
              /> */}

              <h3>Plant Butters: Deep Conditioning and Barrier Repair</h3>

              <p>
                We use natural butters like shea, cocoa, and mango for their
                luxurious texture and skin-conditioning benefits. They are used
                in:
              </p>
              <ul>
                <li>Body butters, balms, and creams for dry, flaky skin</li>
                <li>Lip balms and under-eye treatments</li>
                <li>
                  Hair masks and leave-in conditioners for frizz control and
                  softness
                </li>
              </ul>

              <p>
                These butters create a protective barrier that locks in moisture
                while healing damaged skin.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?shea-butter,body-cream"
                alt="Natural plant butters for body and hair"
              /> */}

              <h3>Why Deww Botanicals Chooses Natural Oils and Extracts</h3>

              <ul>
                <li>100% Natural, Cold-Pressed, and Non-Toxic</li>
                <li>
                  Rich in Vitamins, Antioxidants, and Essential Fatty Acids
                </li>
                <li>Functional, Clean, and Suitable for All Skin Types</li>
                <li>Backed by Ayurvedic Tradition and Modern Science</li>
              </ul>

              <h2>Clean Formulations. Real Results.</h2>

              <p>
                At Deww Botanicals, our mission is to create personal care
                products that are not only effective but also pure and holistic.
                By combining the healing properties of natural oils, butters,
                and extracts, we ensure that every product contributes to
                radiant, balanced, and nourished skin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalCare;
